export const buildComponentAssetPath = ({ screenName, componentMetaId, fieldName }) => {
    const screenPart = screenName ?? ''
    const fieldPart = fieldName ? `-${fieldName}` : ''
    return `${screenPart}-cmp-${componentMetaId}${fieldPart}`
  }